/**
 * pz and pz.general
 * 
 * Provides namespace and general functionality
 * 
 * Requires: jquery
 */

$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.general = function () {

        var initModule = function () {

            // Link elements with data-href attribute defined

            $("[data-href]").on('click', function (event) {
                event.preventDefault();
                window.location.href = $(this).attr('data-href');
            });

            // lightGallery

            if ($('.js-lightgallery').length) {
                $('.js-lightgallery').lightGallery({
                    mode: 'lg-fade',
                    speed: 600,
                    addClass: 'lg-style--white',
                    download: false,
                    counter: false
                });
            }

            // Selection grid
            // Used for product-category-grid, product-class-grid, and customer-service-grid templates

            $('.js-selection-grid-item .overlay').stop().fadeOut(0);

            $('.js-selection-grid-item').on('mouseenter', function (event) {
                event.preventDefault();
                $(this).siblings('.active').find('.overlay').stop().fadeOut();
                $(this).find('.overlay').stop().fadeIn();
                $(this).addClass('active');
            });

            $('.js-selection-grid-item').on('mouseleave', function (event) {
                event.preventDefault();
                $(this).find('.overlay').stop().fadeOut();
                $(this).removeClass('active');
            });

            // Download imprinting template handler
            
            $('.js-imprinting-templates-form').on('click', 'button', function (event) {
                event.preventDefault();
                var url = $('.js-imprinting-templates-form').find('select').val();
                if (url) {
                    downloadFile(url);
                }
            });
        };

        // download file via dynamic download link
        var downloadFile = function(url) {
            var a = $('<a/>')
                .attr('href', url)
                .attr('download', url.substr(url.lastIndexOf('/') + 1))
                .appendTo($('body'));
            a[0].click();
            a.remove();
        }

        return {
            initModule: initModule
        };
    }();

    pz.general.initModule();
});


/**
 * Module Template
 * 
 * Description      Template for javascript modules
 *
 */
$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.module = function () {

        var initModule = function () {};

        return {
            initModule: initModule
        };
    }();

    pz.module.initModule();
});

/**
 * imageLoaded jquery extension
 * 
 * Description      creates a promise which is executed when complete
 *                  see for more details https://stackoverflow.com/questions/4774746/jquery-ajax-wait-until-all-images-are-loaded
 * 
 * Example usage    $.ajax({
                        cache: false,
                        url: 'ajax/content.php',
                        success: function(data) {
                            $('#divajax').html(data).imagesLoaded().then(function(){
                                // do stuff after images are loaded here
                            });
                        }
                    });
 * 
 */
$(function () {
    
    // Fn to allow an event to fire after all images are loaded
    $.fn.imagesLoaded = function () {

        // get all the images (excluding those with no src attribute)
        var $imgs = this.find('img[src!=""]');
        // if there's no images, just return an already resolved promise
        if (!$imgs.length) {return $.Deferred().resolve().promise();}

        // for each image, add a deferred object to the array which resolves when the image is loaded (or if loading fails)
        var dfds = [];  
        $imgs.each(function(){

            var dfd = $.Deferred();
            dfds.push(dfd);
            var img = new Image();
            img.onload = function(){dfd.resolve();}
            img.onerror = function(){dfd.resolve();}
            img.src = this.src;

        });

        // return a master promise object which will resolve when all the deferred objects have resolved
        // IE - when all the images are loaded
        return $.when.apply($,dfds);

    }

});